const useTranslates = (template, values) => {
  return template.replace(/%(\w+)%/g, (match, key) => {
    return values.hasOwnProperty(key) ? values[key] : match;
  });
};

export { useTranslates };
